module.exports = __webpack_public_path__ + "img/35.7439ec7b.jpg";